import { render, staticRenderFns } from "./FpuiHelperPopover.vue?vue&type=template&id=61c53bff&lang=pug&"
import script from "./FpuiHelperPopover.vue?vue&type=script&lang=js&"
export * from "./FpuiHelperPopover.vue?vue&type=script&lang=js&"
import style0 from "./FpuiHelperPopover.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports